export default function WorkProcess() {
  const steps = [
    {
      number: '0',
      title: 'Подготовительный период. Брифинг',
      items: [
        'Постановка задачи',
        'Согласование сроков и бюджета',
        'Согласование перечня услуг',
        'Определение целей бизнеса'
      ],
      icon: 'ri-file-list-3-line'
    },
    {
      number: '1',
      title: 'Погружение и стратегия',
      subtitle: 'Мы начинаем с цифр и психологии',
      items: [
        'Изучаем ваших конкурентов и сегментируем целевую аудиторию',
        'Создаем ваше уникальное торговое предложение (УТП), от которого невозможно отказаться'
      ],
      icon: 'ri-lightbulb-flash-line'
    },
    {
      number: '2',
      title: 'Проектирование архитектуры',
      subtitle: 'Создаем «скелет» будущего сайта, основываясь на поведении пользователей',
      items: [
        'Карта смыслов: Распределяем контент по «Лестнице Ханта», чтобы закрыть боли клиента на каждом этапе',
        'Прототипирование: Прорабатываем логику интерфейса (UX), чтобы путь клиента к покупке был максимально коротким и удобным'
      ],
      icon: 'ri-layout-grid-line'
    },
    {
      number: '3',
      title: 'Копирайтинг и смысловая упаковка',
      subtitle: 'Пишем тексты, которые продают за вас',
      items: [
        'Сильные заголовки: Используем триггеры внимания и доказательства вашей экспертности',
        'Призывы к действию (CTA): Настраиваем формы захвата под разные уровни готовности клиента'
      ],
      icon: 'ri-quill-pen-line'
    },
    {
      number: '4-5',
      title: 'Техническая сборка и визуализация',
      subtitle: 'Воплощаем стратегию в жизнь на высокотехнологичном стеке',
      items: [
        'Адаптивный дизайн: Сайт будет идеально работать на смартфонах, планшетах и ПК',
        'Интеграции: Подключаем мессенджеры, CRM, сервисы рассылок и формы обратной связи'
      ],
      icon: 'ri-code-box-line'
    },
    {
      number: '6',
      title: 'Базовая SEO-оптимизация',
      subtitle: 'Готовим сайт к встрече с поисковыми роботами',
      items: [
        'Настройка мета-тегов: Прописываем заголовки и описания для Google и Яндекса',
        'Локальное Local SEO: Привязываем бизнес к картам и гео-запросам вашего региона'
      ],
      icon: 'ri-seo-line'
    },
    {
      number: '7',
      title: 'Тестирование и запуск',
      subtitle: 'Проверяем всё до последнего пикселя',
      items: [
        'Технический аудит: Контроль скорости загрузки и корректности работы всех кнопок'
      ],
      icon: 'ri-rocket-2-line'
    }
  ];

  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-4 sm:mb-6 leading-tight font-['Playfair_Display']">
            Почему 7 дней — это реально?{' '}
            <span className="hidden sm:inline"><br /></span>
            Этапы создания вашей системы продаж
          </h2>
          <p className="text-base sm:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Скорость не идет в ущерб качеству благодаря системному подходу:
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 gap-5 sm:gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-[#F8F9FA] rounded-3xl p-5 sm:p-8 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300"
            >
              {/* Icon and Number */}
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full flex-shrink-0">
                  <i className={`${step.icon} text-2xl sm:text-3xl text-white`}></i>
                </div>
                <div className="text-3xl sm:text-5xl font-bold text-[#1A2B4C]/20 font-['Playfair_Display']">
                  День {step.number}
                </div>
              </div>

              {/* Title */}
              <h3 className="text-lg sm:text-2xl font-bold text-[#1A2B4C] mb-2 sm:mb-3 font-['Playfair_Display']">
                {step.title}
              </h3>

              {/* Subtitle */}
              {step.subtitle && (
                <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4 italic font-['Montserrat'] text-justify">
                  {step.subtitle}
                </p>
              )}

              {/* Items */}
              <ul className="space-y-2 sm:space-y-3">
                {step.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-5 h-5 bg-[#C5A880] rounded-full flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
                      {item}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}